import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    uid: null,
    email: "",
    organizationId: null,
    organizationName: null,
    authInitializing: true,
    firstName: "",
    lastName: "",
    stripe_connected_account_id: "",
    stripe_charges_enabled: null,
    stripe_payouts_enabled: null,
    stripe_account_status: null,
    stripe_requirements_pending_count: 0,
    stripe_dashboard_attention_required: false,
    // Phase 2 additions
    isSystemAdmin: false,
    orgRole: null, // 'ADMIN' or 'VIEWER'
    memberships: [], // Array of all user memberships
    activeOrgId: null, // Currently selected organization
  },
  reducers: {
    setUser: (state, action) => {
      state.uid = action.payload.uid;
      state.email = action.payload.email;
      state.organizationId = action.payload.organizationId;
      state.organizationName = action.payload.organizationName;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.stripe_connected_account_id =
        action.payload.stripe_connected_account_id;
      state.stripe_charges_enabled = action.payload.stripe_charges_enabled;
      state.stripe_payouts_enabled = action.payload.stripe_payouts_enabled;
      state.stripe_account_status = action.payload.stripe_account_status;
      state.stripe_requirements_pending_count =
        action.payload.stripe_requirements_pending_count ?? 0;
      state.stripe_dashboard_attention_required =
        action.payload.stripe_dashboard_attention_required ?? false;
      // Phase 2 fields
      state.isSystemAdmin = action.payload.isSystemAdmin || false;
      state.orgRole = action.payload.orgRole || null;
      state.memberships = action.payload.memberships || [];
      state.activeOrgId =
        action.payload.activeOrgId || action.payload.organizationId;
    },
    clearUser: (state) => {
      state.uid = null;
      state.email = "";
      state.organizationId = null;
      state.organizationName = null;
      state.firstName = "";
      state.lastName = "";
      state.stripe_connected_account_id = "";
      state.stripe_charges_enabled = null;
      state.stripe_payouts_enabled = null;
      state.stripe_account_status = null;
      state.stripe_requirements_pending_count = 0;
      state.stripe_dashboard_attention_required = false;
      state.isSystemAdmin = false;
      state.orgRole = null;
      state.memberships = [];
      state.activeOrgId = null;
    },
    setAuthInitializing: (state, action) => {
      state.authInitializing = action.payload;
    },
    setActiveOrganization: (state, action) => {
      // Switch to a different organization from memberships
      const membership = (state.memberships || []).find(
        (m) => m.organization_id === action.payload.organizationId
      );
      if (membership) {
        state.activeOrgId = membership.organization_id;
        state.organizationId = membership.organization_id;
        state.organizationName = membership.organization_name;
        state.orgRole = membership.role;
      }
    },
    updateMemberships: (state, action) => {
      state.memberships = action.payload;
    },
  },
});

export const {
  setUser,
  clearUser,
  setAuthInitializing,
  setActiveOrganization,
  updateMemberships,
} = userSlice.actions;

// Selectors
export const selectCanWrite = (state) => state.user.orgRole === "ADMIN";
export const selectCanInvite = (state) => state.user.orgRole === "ADMIN";
export const selectCanRefund = (state) => state.user.orgRole === "ADMIN";
export const selectIsSystemAdmin = (state) => state.user.isSystemAdmin;
export const selectHasMultipleOrgs = (state) =>
  (state.user.memberships || []).length > 1;

export default userSlice.reducer;
